import React from "react";
import ChannelSliderItem from "./ChannelSliderItem";
import "./ChannelSlider.scss";

const ChannelSliders = ({ channels = [] }) => {
    const items = channels.length ? channels : Array(4).fill({});

    return (
        <div className="container">
            <div className="row">
                {items.map((channel, idx) => (
                    <ChannelSliderItem
                        key={channel.id || `skeleton-${idx}`}
                        index={idx}
                        channel={channel}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChannelSliders;
